import React from "react";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";

const getCurrentDate = () => {
  const date = Date().slice(0, 15).split(" ");
  return `${date[0]}, ${date[1]} ${date[2]}, ${date[3]}`;
};

export default function AnalyticsHeader({title, subtitle = "All Subjects", background = "linear-gradient(135deg, #4f46e5, #06b6d4)"}) {
  return (
    <div
      style={{
        background,
        borderRadius: "12px",
        padding: "16px 20px",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        gap: "6px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2 style={{ fontSize: "2.5rem", fontWeight: 700, margin: 0 }}>
          {title}
        </h2>

        <div style={{ fontSize: "1rem", display: "flex", gap: "6px" }}>
          <CalendarTodayIcon style={{ width: 16 }} />
          {getCurrentDate()}
        </div>
      </div>

      <p style={{ fontSize: "1.25rem", margin: 0, opacity: 0.9 }}>
        {subtitle}
      </p>
    </div>
  );
}